import React, { useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import Tooltip from "react-native-walkthrough-tooltip";

interface FieldWithTooltipProps {
  label: string;
  description: string;
}

function FieldWithTooltip({
  label,
  description,
}: FieldWithTooltipProps): React.JSX.Element {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  return (
    <View style={styles.container}>
      <Text style={styles.label}>{label}</Text>
      <Tooltip
        isVisible={showTooltip}
        content={<Text style={styles.tooltipContent}>{description}</Text>}
        placement="top"
        onClose={() => setShowTooltip(false)}
        backgroundStyle={styles.tooltipBackground}
        contentStyle={styles.tooltipContentContainer}
      >
        <TouchableOpacity onPress={() => setShowTooltip(!showTooltip)}>
          <FontAwesome name="info-circle" size={18} color="#4A5568" />
        </TouchableOpacity>
      </Tooltip>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  label: {
    fontSize: 16,
    fontWeight: "400",
    color: "#000000",
    marginRight: 5,
  },
  tooltipContent: {
    fontSize: 14,
    color: "#000000",
    flexWrap: "wrap",
  },
  tooltipBackground: {
    backgroundColor: "white",
  },
  tooltipContentContainer: {
    maxWidth: 300,
    minWidth: 100,
  },
});

export default FieldWithTooltip;
